export const VIP_MEMBERSHIP_PRICE = 29.99
